import { Component, OnInit, Output, Input, ViewChild, EventEmitter } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatMenuTrigger } from '@angular/material/menu';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { IUserSelectorSettings } from 'src/app/chat/dialogs/user-selector-dlg/user-selector-dlg.interface';
import { IUser, UserAccountType } from 'src/app/data-types/user-data';
import {
    ILeadFormDlgResult,
    LeadFormComponent,
    LeadFormDlgDataParams,
} from 'src/app/leads/lead-form/lead-form.component';
import { User } from '../../model/model';

@UntilDestroy()
@Component({
    selector: 'app-user-selector-dropdown',
    templateUrl: './user-selector-dropdown.component.html',
    styleUrls: ['./user-selector-dropdown.component.scss'],
})
export class UserSelectorDropdownComponent implements OnInit {
    @Input() preSelectedUser: IUser = null;
    @Input() showCreateLeadBtn = true;
    @Output() userSelected = new EventEmitter();
    @ViewChild('dropdownTrigger') dropdownTrigger: MatMenuTrigger;

    userSelectorSettings: IUserSelectorSettings = {
        mode: 'single',
        showTypeSelector: false,
        showUserPhones: true,
        showCompnayName: false,
        avatarSize: 24,
        phoneEmailTopToggle: true,
        selectByClick: true,
        showCreateLeadBtn: this.showCreateLeadBtn,
        allowedUserTypes: [UserAccountType.Customer, UserAccountType.Trade, UserAccountType.Guest],
    };
    selectedCustomerId: string = null;
    selectedCustomerName: string = null;

    constructor(public dialog: MatDialog) {}

    ngOnInit(): void {
        if (this.preSelectedUser) {
            this.selectedCustomerName = this.preSelectedUser.firstname + ' ' + this.preSelectedUser.surname;
            this.selectedCustomerId = this.preSelectedUser.id;
        }
        this.userSelectorSettings.showCreateLeadBtn = this.showCreateLeadBtn;
    }

    selectUser(user) {
        this.selectedCustomerName = user.contact.firstname + ' ' + user.contact.surname;
        this.selectedCustomerId = user.id;
        this.userSelected.emit({
            ...user,
            firstname: user.contact.firstname,
            surname: user.contact.surname,
            email: user.contact.email,
            mobile: user.contact.mobile,
        } as IUser);
        this.dropdownTrigger.closeMenu();
    }

    unselectUser() {
        this.selectedCustomerName = null;
        this.selectedCustomerId = null;
        this.userSelected.emit(null);
    }

    showCreateCustomerDlg() {
        this.dropdownTrigger.closeMenu();
        this.dialog
            .open(LeadFormComponent, {
                ...LeadFormDlgDataParams,
            })
            .afterClosed()
            .pipe(untilDestroyed(this))
            .subscribe((data: ILeadFormDlgResult) => {
                if (data?.status === true) {
                    this.selectedCustomerId = data.lead.id;
                    this.selectedCustomerName = `${data.lead.contact.firstname} ${data.lead.contact.surname}`;
                    this.userSelected.emit(data.lead);
                }
            });
    }
}
